import { Component, Prop, Vue } from 'vue-property-decorator';
import { Debounce } from '@/decorators';
import { Pagination } from '@/models';

@Component
export default class ProjectCardsPagination extends Vue {
  pagination: Pagination = { pageIndex: 1, itemsPerPage: 5, totalLength: 1 };

  @Prop() private totalPageLength: number;

  @Debounce(500)
  onPageChange() {
    this.$emit('onPaginationChange', this.pagination);
  }
}
